<template>
    <div class='photographer-main'>
        <div class='tabs is-midium is-boxed'>
            <ul>
                <li @click='changeMode("upload")' v-bind:class='{ "is-active": upload }'>
                    <a>
                        <span class='icon is-small'><i class='fas fa-image' aria-hidden='true'></i></span>
                        <span>写真アップロード</span>
                    </a>
                </li>
                <li @click='changeMode("setting")' v-bind:class='{ "is-active": setting }'>
                    <a>
                        <span class='icon is-small'><i class='fas fa-cog' aria-hidden='true'></i></span>
                        <span>詳細設定</span>
                    </a>
                </li>
                <li @click='changeMode("humans")' v-bind:class='{ "is-active": humans }'>
                    <a>
                        <span class='icon is-small'><i class='fas fa-user' aria-hidden='true'></i></span>
                        <span>生徒</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class='photographer-main-content'>
            <Setting v-if='setting' :selectEvent='selectEvent'></Setting>
            <Upload v-else-if='upload' :selectEvent='selectEvent'></Upload>
            <Humans v-else-if='humans' :selectEvent='selectEvent'></Humans>
        </div>
    </div>
</template>

<script>

import Upload from '@/components/photographer/pages/Upload.vue'
import Setting from '@/components/photographer/pages/Setting.vue'
import Humans from '@/components/photographer/pages/Humans.vue'

export default {
    name: 'PhotographerMain',
    props: ['selectEvent'],
    components: {
        Setting,
        Upload,
        Humans
    },
    data () {
        return {
            setting: false,
            upload: true,
            humans: false
        }
    },
    mounted () {
    },
    methods: {
        changeMode (mode) {
            this.$data.setting = false
            this.$data.upload = false
            this.$data.humans = false

            if (mode === 'upload') {
                this.$data.upload = true
            } else if (mode === 'setting') {
                this.$data.setting = true
            } else if (mode === 'humans') {
                this.$data.humans = true
            }
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}

.photographer-main {
    margin-top: 10px;
    max-width: 1280px;
}

.photographer-main-content {
    padding: 25px;
    margin: 0;
    width: 100%;
    max-width: 1000px;
    padding-left: 80px;
}

.mode-change {
    font-size: 20px;
    font-weight: bold;
    color: rgb(77, 139, 255);
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/Main.vue